import script from "./UserActivityLog.vue?vue&type=script&setup=true&lang=js"
export * from "./UserActivityLog.vue?vue&type=script&setup=true&lang=js"

import "./UserActivityLog.vue?vue&type=style&index=0&id=4ae49d69&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ae49d69"]])

export default __exports__